module.exports = __webpack_public_path__ + "static/media/chat.d649e296.svg";